'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var pipe = require('it-pipe');

var pushable = require('it-pushable');

var log = require('debug')('libp2p:mplex');

var abortable = require('abortable-iterator');

var Coder = require('./coder');

var restrictSize = require('./restrict-size');

var _require = require('./message-types'),
    MessageTypes = _require.MessageTypes,
    MessageTypeNames = _require.MessageTypeNames;

var createStream = require('./stream');

var Mplex = /*#__PURE__*/function () {
  /**
   * @class
   * @param {object} options
   * @param {function(*)} options.onStream - Called whenever an inbound stream is created
   * @param {function(*)} options.onStreamEnd - Called whenever a stream ends
   * @param {AbortSignal} options.signal - An AbortController signal
   */
  function Mplex(options) {
    _classCallCheck(this, Mplex);

    options = options || {};
    options = typeof options === 'function' ? {
      onStream: options
    } : options;
    this._streamId = 0;
    this._streams = {
      /**
       * @type {Map<number, *>} Stream to ids map
       */
      initiators: new Map(),

      /**
       * @type {Map<number, *>} Stream to ids map
       */
      receivers: new Map()
    };
    this._options = options;
    /**
     * An iterable sink
     */

    this.sink = this._createSink();
    /**
     * An iterable source
     */

    this.source = this._createSource();
    /**
     * @property {Function} onStream
     */

    this.onStream = options.onStream;
    /**
     * @property {Function} onStreamEnd
     */

    this.onStreamEnd = options.onStreamEnd;
  }
  /**
   * Returns a Map of streams and their ids
   *
   * @returns {Map<number,*>}
   */


  _createClass(Mplex, [{
    key: "streams",
    get: function get() {
      // Inbound and Outbound streams may have the same ids, so we need to make those unique
      var streams = [];

      this._streams.initiators.forEach(function (stream) {
        streams.push(stream);
      });

      this._streams.receivers.forEach(function (stream) {
        streams.push(stream);
      });

      return streams;
    }
    /**
     * Initiate a new stream with the given name. If no name is
     * provided, the id of th stream will be used.
     *
     * @param {string} [name] - If name is not a string it will be cast to one
     * @returns {Stream}
     */

  }, {
    key: "newStream",
    value: function newStream(name) {
      var id = this._streamId++;
      name = name == null ? id.toString() : String(name);
      var registry = this._streams.initiators;
      return this._newStream({
        id: id,
        name: name,
        type: 'initiator',
        registry: registry
      });
    }
    /**
     * Called whenever an inbound stream is created
     *
     * @private
     * @param {*} options
     * @param {number} options.id
     * @param {string} options.name
     * @returns {*} A muxed stream
     */

  }, {
    key: "_newReceiverStream",
    value: function _newReceiverStream(_ref) {
      var id = _ref.id,
          name = _ref.name;
      var registry = this._streams.receivers;
      return this._newStream({
        id: id,
        name: name,
        type: 'receiver',
        registry: registry
      });
    }
    /**
     * Creates a new stream
     *
     * @private
     * @param {object} options
     * @param {number} options.id
     * @param {string} options.name
     * @param {string} options.type
     * @param {Map<number, *>} options.registry - A map of streams to their ids
     * @returns {*} A muxed stream
     */

  }, {
    key: "_newStream",
    value: function _newStream(_ref2) {
      var _this = this;

      var id = _ref2.id,
          name = _ref2.name,
          type = _ref2.type,
          registry = _ref2.registry;

      if (registry.has(id)) {
        throw new Error("".concat(type, " stream ").concat(id, " already exists!"));
      }

      log('new %s stream %s %s', type, id, name);

      var send = function send(msg) {
        if (log.enabled) {
          log('%s stream %s %s send', type, id, name, _objectSpread(_objectSpread({}, msg), {}, {
            type: MessageTypeNames[msg.type],
            data: msg.data && msg.data.slice()
          }));
        }

        return _this.source.push(msg);
      };

      var onEnd = function onEnd() {
        log('%s stream %s %s ended', type, id, name);
        registry.delete(id);
        _this.onStreamEnd && _this.onStreamEnd(stream);
      };

      var stream = createStream({
        id: id,
        name: name,
        send: send,
        type: type,
        onEnd: onEnd,
        maxMsgSize: this._options.maxMsgSize
      });
      registry.set(id, stream);
      return stream;
    }
    /**
     * Creates a sink with an abortable source. Incoming messages will
     * also have their size restricted. All messages will be varint decoded.
     *
     * @private
     * @returns {*} Returns an iterable sink
     */

  }, {
    key: "_createSink",
    value: function _createSink() {
      var _this2 = this;

      return /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (_this2._options.signal) {
                    source = abortable(source, _this2._options.signal);
                  }

                  _context2.prev = 1;
                  _context2.next = 4;
                  return pipe(source, Coder.decode, restrictSize(_this2._options.maxMsgSize), /*#__PURE__*/function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
                      var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, msgs, _iterator2, _step2, msg;

                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _iteratorAbruptCompletion = false;
                              _didIteratorError = false;
                              _context.prev = 2;
                              _iterator = _asyncIterator(source);

                            case 4:
                              _context.next = 6;
                              return _iterator.next();

                            case 6:
                              if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                                _context.next = 13;
                                break;
                              }

                              msgs = _step.value;
                              _iterator2 = _createForOfIteratorHelper(msgs);

                              try {
                                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                                  msg = _step2.value;

                                  _this2._handleIncoming(msg);
                                }
                              } catch (err) {
                                _iterator2.e(err);
                              } finally {
                                _iterator2.f();
                              }

                            case 10:
                              _iteratorAbruptCompletion = false;
                              _context.next = 4;
                              break;

                            case 13:
                              _context.next = 19;
                              break;

                            case 15:
                              _context.prev = 15;
                              _context.t0 = _context["catch"](2);
                              _didIteratorError = true;
                              _iteratorError = _context.t0;

                            case 19:
                              _context.prev = 19;
                              _context.prev = 20;

                              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                                _context.next = 24;
                                break;
                              }

                              _context.next = 24;
                              return _iterator.return();

                            case 24:
                              _context.prev = 24;

                              if (!_didIteratorError) {
                                _context.next = 27;
                                break;
                              }

                              throw _iteratorError;

                            case 27:
                              return _context.finish(24);

                            case 28:
                              return _context.finish(19);

                            case 29:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, null, [[2, 15, 19, 29], [20,, 24, 28]]);
                    }));

                    return function (_x2) {
                      return _ref4.apply(this, arguments);
                    };
                  }());

                case 4:
                  _context2.next = 10;
                  break;

                case 6:
                  _context2.prev = 6;
                  _context2.t0 = _context2["catch"](1);
                  log('error in sink', _context2.t0);
                  return _context2.abrupt("return", _this2.source.end(_context2.t0));

                case 10:
                  _this2.source.end();

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[1, 6]]);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }();
    }
    /**
     * Creates a source that restricts outgoing message sizes
     * and varint encodes them.
     *
     * @private
     * @returns {*} An iterable source
     */

  }, {
    key: "_createSource",
    value: function _createSource() {
      var _this3 = this;

      var onEnd = function onEnd(err) {
        var _this3$_streams = _this3._streams,
            initiators = _this3$_streams.initiators,
            receivers = _this3$_streams.receivers; // Abort all the things!

        var _iterator3 = _createForOfIteratorHelper(initiators.values()),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var s = _step3.value;
            s.abort(err);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        var _iterator4 = _createForOfIteratorHelper(receivers.values()),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _s = _step4.value;

            _s.abort(err);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      };

      var source = pushable({
        onEnd: onEnd,
        writev: true
      });
      return Object.assign(Coder.encode(source), {
        push: source.push,
        end: source.end,
        return: source.return
      });
    }
    /**
     * @private
     * @param {object} options
     * @param {number} options.id
     * @param {string} options.type
     * @param {Uint8Array|BufferList} options.data
     * @returns {void}
     */

  }, {
    key: "_handleIncoming",
    value: function _handleIncoming(_ref5) {
      var id = _ref5.id,
          type = _ref5.type,
          data = _ref5.data;

      if (log.enabled) {
        log('incoming message', {
          id: id,
          type: MessageTypeNames[type],
          data: data.slice()
        });
      } // Create a new stream?


      if (type === MessageTypes.NEW_STREAM && this.onStream) {
        var _stream = this._newReceiverStream({
          id: id,
          name: data.toString()
        });

        return this.onStream(_stream);
      }

      var list = type & 1 ? this._streams.initiators : this._streams.receivers;
      var stream = list.get(id);
      if (!stream) return log('missing stream %s', id);

      switch (type) {
        case MessageTypes.MESSAGE_INITIATOR:
        case MessageTypes.MESSAGE_RECEIVER:
          stream.source.push(data);
          break;

        case MessageTypes.CLOSE_INITIATOR:
        case MessageTypes.CLOSE_RECEIVER:
          stream.close();
          break;

        case MessageTypes.RESET_INITIATOR:
        case MessageTypes.RESET_RECEIVER:
          stream.reset();
          break;

        default:
          log('unknown message type %s', type);
      }
    }
  }]);

  return Mplex;
}();

Mplex.multicodec = '/mplex/6.7.0';
module.exports = Mplex;